import { Outlet } from "react-router-dom";
import Header from "src/components/home/header/Header";
import Footer from "src/components/home/footer/Footer";

export default function MainLayout() {
  return (
    <>
      <Header />
      <div className="min-h-screen">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
